import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultOtpMessage: {
    id: 'verify.email.sent.body.otp.default.message',
    defaultMessage: "To proceed, enter the code we've sent to:",
    description:
      'Text telling the user to enter the OTP sent to their email to verify their account to proceed to the next step',
  },
  signUpOtpMessage: {
    id: 'verify.email.sent.body.otp.sign-up.message',
    defaultMessage: "To complete your account setup, enter the code we've sent to:",
    description:
      'Text telling the user to enter the OTP sent to their email to verify their account and complete account setup',
  },
  loginChallengeOtpMessage: {
    id: 'verify.email.sent.body.otp.login-challenge.message',
    defaultMessage:
      'We require additional verification to protect your account. Check your email to continue:',
    description:
      'Text telling the user to enter the OTP sent to their email to verify their account to proceed with the login',
  },
  invalidOtpErrorMessage: {
    id: 'verify.email.error-message.invalid-otp',
    defaultMessage: 'Provided verification code is invalid',
    description:
      'Error message informing the user that the OTP code they have entered is incorrect',
  },
  invalidOtpLengthErrorMessage: {
    id: 'verify.email.error-message.invalid-otp-length',
    defaultMessage: 'Complete the verification code',
    description:
      'Error message informing the user that the OTP code they have entered is of an incorrect length',
  },
  invalidTokenErrorMessage: {
    id: 'verify.email.error-message.invalid-token',
    defaultMessage: 'Invalid token',
    description:
      'Error message returned when the token associated with the verification transaction is invalid',
  },
  expiredTokenErrorMessage: {
    id: 'verify.email.error-message.expired-token',
    defaultMessage: 'Token expired',
    description:
      'Error message returned when the token associated with the verification transaction is expired',
  },
  rateLimitedErrorMessage: {
    id: 'verify.email.error-message.rate-limited',
    defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.',
    description: 'Error message returned when rate limited due to too many requests',
  },
  unexpectedErrorErrorMessage: {
    id: 'verify.email.error-message.unexpected',
    defaultMessage: 'Unexpected error',
    description: 'Error message returned when there is an unexpected error',
  },
  emailOtpVerifyHeader: {
    id: 'verify.email.otp.sent.title',
    defaultMessage: `We've sent you an email!`,
    description: 'Title of the component that lets them input the code to verify their email',
  },
  resendOtpButton: {
    id: 'welcome.sent.resend.signup.otp',
    defaultMessage: `Didn't receive an email? Resend email`,
    description:
      'Text telling the user that they can resend the welcome OTP email again for verification.',
  },
  headOtpTitle: {
    id: 'verify.email.sent.otp.head.title',
    defaultMessage: `We've emailed you a code`,
    description: 'Text telling the user that they were sent an email with an OTP',
  },
  submitButton: {
    id: 'verify.email.signup.submit',
    defaultMessage: 'Verify',
    description: 'Text used for the button that submits the OTP for verification.',
  },
  otpInputGroupLabel: {
    id: 'verify.email.otp.input.label',
    defaultMessage: 'Verification code',
    description:
      'Accessible label for the group of inputs that make up the one-time verification code, announced by screen readers when focus enters the group',
  },
});
